import React, { useContext } from 'react';
import gettext from '@eb/gettext';
import { Tabs } from '@eb/eds-tabs';
import { withEventSaveNotification } from '@eb/redux-destination';

import { EventContext } from '../context';
import { DiscoveryEvent } from '../types';

import { EventRenderer } from './EventRenderer';
import { ShowMoreEvents } from './ShowMoreEvents';

function notUndefined<T>(x: T | undefined): x is T {
    return x !== undefined;
}

const filterEvents = (
    events: (DiscoveryEvent | undefined)[],
): DiscoveryEvent[] => {
    return events.filter(notUndefined);
};

const OrganizerEventsInternal: React.FunctionComponent = (props) => {
    const { state } = useContext(EventContext);
    const futureEventIds = state?.future.events || [];
    const pastEventIds = state?.past.events || [];
    const futureEvents = futureEventIds.map((id) => state?.events[id]);
    const pastEvents = pastEventIds.map((id) => state?.events[id]);

    const upcomingEventsTabsItem = {
        displayName: `${gettext('Live Events')} ${state?.future.num || ''}`,
        content: (
            <section className="eds-l-pad-hor-2">
                <EventRenderer events={filterEvents(futureEvents)} />
                <ShowMoreEvents showFuture={true} />
            </section>
        ),
        value: 0,
    };

    const pastEventsTabsItem = {
        displayName: `${gettext('Past Events')} ${state?.past.num || ''}`,
        content: (
            <section className="eds-l-pad-hor-2">
                <EventRenderer
                    events={filterEvents(pastEvents)}
                    removeSaveHandlers={true}
                />
                <ShowMoreEvents showFuture={false} />
            </section>
        ),
        value: 1,
    };

    return (
        <section className="organizer-events">
            <Tabs items={[upcomingEventsTabsItem, pastEventsTabsItem]} />
        </section>
    );
};

export const OrganizerEvents = withEventSaveNotification(
    OrganizerEventsInternal,
);
